var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgZapier = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "16.000000pt",
  height: "16.000000pt",
  viewBox: "0 0 16.000000 16.000000",
  preserveAspectRatio: "xMidYMid meet"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,16.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M70 133 c0 -25 -1 -25 -18 -10 -24 22 -37 9 -15 -15 15 -17 15 -18 -10 -18 -15 0 -27 -4 -27 -10 0 -5 12 -10 27 -10 25 0 25 -1 10 -18 -22 -24 -9 -37 15 -15 17 15 18 15 18 -10 0 -15 5 -27 10 -27 6 0 10 12 10 27 0 25 1 25 18 10 24 -22 37 -9 15 15 -15 17 -15 18 10 18 15 0 27 5 27 10 0 6 -12 10 -27 10 -25 0 -25 1 -10 18 22 24 9 37 -15 15 -17 -15 -18 -15 -18 10 0 15 -4 27 -10 27 -5 0 -10 -12 -10 -27z m30 -53 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13 7 20 20 20 13 0 20 -7 20 -20z"
}))));
export { SvgZapier as ReactComponent };
export default __webpack_public_path__ + "4aa6be9731d1361dae8f2eb10bd640ec.svg";